import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SkinFilledSvg from "@ant-design/icons-svg/es/asn/SkinFilled";
import AntdIcon from '../components/AntdIcon';
var SkinFilled = function SkinFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: SkinFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(SkinFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'SkinFilled';
}
export default RefIcon;